import { useRef } from 'react';

import { Box, IconButton } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';


const FUNCTION = "function";
const CustomHeaderMenuIcon = (props) => {
  const { displayName, isClicked, isQuestion, onClickedEvent, showColumnMenu, column, isSorting } = props;
  const refButton = useRef(null);
  const orders = [null, 'asc', 'desc'];

  const onMenuClicked = (event) => {
    if (typeof isClicked === FUNCTION) {
      isClicked(true)
    }

    if (typeof onClickedEvent === FUNCTION) {
      onClickedEvent(event.currentTarget);
    }
  };
  
  const onSortRequested = (event, column) => {
    let currentIndex = 0;
    const direction = column?.getSort();
    if (column && direction && (direction === "asc" || direction === "desc")) {
      currentIndex = orders.indexOf(direction);
    }
    const nextOrderIdx = (currentIndex + 1) % 3;
    //설정버튼 클릭과 글씨클릭 구분 필요. 글씨클릭시에만 sort되도록
    if (event.target?.localName !== "span") {
      return;
    }
    props.setSort(orders[nextOrderIdx], event.shiftKey);
  };

  const getSortIcon = (order) => {
    if (order === "asc" || order === "desc") {
      return (
        <Box className="ag-sort-indicator-icon" component="span" style={{ display: 'inline-flex' }}>
          <Box
            className={`ag-icon ag-icon-${order === 'asc' ? 'asc' : 'desc'}`}
            component="span"
          />
        </Box>
      );
    }

    return "";
  };

  const HeaderIcon = () => {
    return (
      <IconButton ref={refButton} className="customHeaderMenuButton" aria-label="collapsed" size="small" onClick={onMenuClicked}>
        {isQuestion ? <QuestionMarkIcon color="primary" sx={{ fontSize: "12px" }} /> : <SettingsIcon color="default" sx={{ fontSize: "14px" }} />}
      </IconButton>
    )
  }

  return (
    <Box className="ag-cell-label-container" role="presentation">
      {column.colId === "custlevel" || column.colId === "productlevel" ?
       <Box className="ag-header-icon ag-header-cell-menu-button ag-header-menu-always-show">
        <span className="ag-icon ag-icon-menu" role="presentation" onClick={(e) => {if (e) {showColumnMenu(e.currentTarget)}}} ></span>
        {/* <span className="ag-icon ag-icon-menu" role="presentation"  onClick={(e) => {isPopUp.current = "visible"}} ></span> */}
      </Box> : null }
      <Box className="ag-header-cell-label" onClick={(e) => isSorting ? onSortRequested(e, column) : null}>
        <Box className='ag-header-cell-text' component="span">{displayName}</Box>
        {isSorting ? getSortIcon(column.getSort()) : null}
        <HeaderIcon />
      </Box>
    </Box>
  );
};

export default CustomHeaderMenuIcon;
